import { Outlet, useParams } from 'react-router'
import { useDeviceType } from '~/common/hooks/useDeviceQuery'
import { lazy } from '~/router/lazy'
import { RouteObject } from '~/router/types'
import { DossbotLeftNav } from './DossbotLeftNav'

export const dossbotRoute: RouteObject = {
  path: 'dossbot',
  Component: DossbotLayout,
  handle: {
    pageType: 'dossbot',
    group: 'dossbot',
    showLeftNav: false,
  },
  children: [
    { path: 'chat', lazy: lazy(() => import('./DossbotChatRedirect')) },
    { path: 'chat/new', lazy: lazy(() => import('./DossbotHome')) },
    { path: 'chat/:chat_id', lazy: lazy(() => import('./DossbotHome')) },
  ],
}

/**
 * Dossbot layout — renders the chat sidebar on desktop, pass-through on mobile.
 */
function DossbotLayout() {
  const { isMobile } = useDeviceType()
  const { chat_id } = useParams()

  if (isMobile) {
    return <Outlet />
  }

  return (
    <div className="flex h-full">
      <DossbotLeftNav chatId={chat_id} />
      <div className="flex-1 overflow-hidden">
        <Outlet />
      </div>
    </div>
  )
}
